export const getProvinces = ({ options }) => {
    return Array.from(options.get('cities')).map(value => (value ? value.toObject() : {}));
};
